import React from "react";
import { withScriptjs, withGoogleMap, GoogleMap } from "react-google-maps";
import EventMarker from "./eventMarker";

const { MarkerClusterer } = require("react-google-maps/lib/components/addons/MarkerClusterer");

const ActivityMap = withScriptjs(withGoogleMap((props) =>{

    onMarkerClustererClick: () => (markerClusterer) => {
        const clickedMarkers = markerClusterer.getMarkers();
      };
      
  const google=window.google;
  const mapoptions = function(){
    return {
        mapOptions : {
            mapTypeId: google.maps.MapTypeId.SATELLITE,
            mapTypeControl: true,
            mapTypeControlOptions: {
                style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                position: google.maps.ControlPosition.TOP_RIGHT
            },
            panControl: true,
            panControlOptions: {
                position: google.maps.ControlPosition.RIGHT_TOP
            },
            zoomControl: true,
            zoomControlOptions: {
                style: google.maps.ZoomControlStyle.LARGE,
                position: google.maps.ControlPosition.RIGHT_TOP
            },
            scaleControl: true,
            scaleControlOptions: {
                position: google.maps.ControlPosition.RIGHT_TOP
            },
            streetViewControl: false,
            scrollwheel: false
        }
    }
};
  
  const markers = props.events.map( event => 
                  <EventMarker
                    icon={event.eventName}
                    location={{lat: parseFloat(event.where_shareEventLog.split(",")[0]), lng: parseFloat(event.where_shareEventLog.split(",")[1])}}
                  />);                

  return (
    <GoogleMap
            defaultZoom={4}
            center={{ lat:  40.1020, lng: -88.2272 }}
            options={mapoptions}
            >
    
          <MarkerClusterer
            onClick={props.onMarkerClustererClick}
            averageCenter
            enableRetinaIcons
            gridSize={1}
            maxZoom={20}
          >
            {markers}
          </MarkerClusterer>
        </GoogleMap>
      );
  }
))

export default ActivityMap;
